module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('licence.title'),
      "isBackground": true
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-licence-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "user-licence"
  }, [_c('img', {
    staticClass: "licence-icon",
    attrs: {
      "src": "/static/images/ic-license-code.svg"
    }
  }), _vm._v(" "), (_vm.isUserLicence) ? _c('h5', {
    staticClass: "licence-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('licence.register_confirm', {
        user: _vm.currentUserName
      }))
    }
  }) : _c('h4', {
    staticClass: "licence-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('licence.form_title'))
    }
  }), _vm._v(" "), (_vm.isUserLicence) ? _c('div', {
    staticClass: "licence-card"
  }, [_c('h5', {
    staticClass: "licence-card-title"
  }, [_vm._v(_vm._s(_vm.$t('licence.sub_title')))]), _vm._v(" "), _c('div', {
    staticClass: "licence-card-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('licence.register_period')))]), _vm._v(" "), _c('div', {
    staticClass: "licence-card-date"
  }, [_vm._v(_vm._s(_vm.licenceStartDate) + "~" + _vm._s(_vm.licenceEndDate))])]) : _c('div', {
    staticClass: "row form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenceCode),
      expression: "licenceCode"
    }],
    staticClass: "form-control licence-code-field",
    attrs: {
      "type": "text",
      "placeholder": _vm.fieldPlaceholder,
      "required": ""
    },
    domProps: {
      "value": (_vm.licenceCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenceCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "licence-code-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.isLicenceCode || _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.submitLicenceCode()
      }
    }
  }, [(_vm.busy) ? _c('LoadingBounce') : [_vm._v(_vm._s(_vm.$t('licence.register')))]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "licence-benefit"
  }, [_c('h5', {
    staticClass: "benefit-title"
  }, [_vm._v(_vm._s(_vm.$t('licence.benefit_title')))]), _vm._v(" "), _vm._l((_vm.benefitItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "benefit-item"
    }, [_c('img', {
      attrs: {
        "src": "/static/images/ic-check.svg",
        "alt": "icon"
      }
    }), _vm._v(" " + _vm._s(item) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.isSuccess) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": false,
      "title": _vm.$t('licence.register_success'),
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.isSuccess = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.successText)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": true,
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.isError = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorText)
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d4e8da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/user-licence/views/UserLicence.vue
// module id = 1591
// module chunks = 1